import Accordion from './Classes/Accordion';
import BackToTop from './Classes/BackToTop';
import DownloadCenter from './Classes/DownloadCenter';
import Flipbox from './Classes/Flipbox';
import FlipboxSlider from './Classes/FlipboxSlider';
import Footnotes from './Classes/Footnotes';
import KeyfigureTabs from './Classes/KeyfigureTabs';
import LazyLoad from 'vanilla-lazyload';
import Link from './Classes/Link';
import MegatrendCard from './Classes/MegatrendCard';
import Member from './Classes/Member';
import NavigationResponsive from './Classes/NavigationResponsive';
import Navigation from './Classes/Navigation';
import ReadingProgress from './Classes/ReadingProgress';
import ScreenVideo from './Classes/ScreenVideo';
import SearchCounter from './Classes/SearchCounter';
import ShareholderLetter from './Classes/ShareholderLetter';
import Slider from "./Classes/Slider";
import SliderHighlights from './Classes/SliderHighlights';
import StickyNav from './Classes/StickyNav';
import Video from "./Classes/Video";
import GRI from "./Classes/Gri";
import Worldmap from "./Classes/Worldmap";
import ResponsiveTable from "./Classes/ResponsiveTable";
import Symbols from "./Classes/Symbols";
import SVGLightboxInstance from './Classes/svgLightboxInstance';
import swiper from './lib/swiper';
import LottieScrollAnimator from './Classes/LottieScrollAnimator.js';
import ChartsInPopUp from "./Classes/ChartsInPopUp";
import ChapterVideo from './Classes/ChapterVideo';
import Anchor from "./Classes/Anchor";
import BoxStory from './Classes/BoxStory';
import NotesLazyLoad from './Classes/NotesLazyLoad';

let anchorInstance = null;
let boxStoryInstance = null;
let chapterVideoInstance = null;
let notesLazyLoadInstance = null;
let chartsInPopUp = null;
let responsiveTableInstance = null;
let accordionInstance = null;
let megatrendCardInstance = null;
let backToTopInstance = null;
let downloadcenterInstance = null;
let flipboxInstance = null;
let flipboxSliderInstance = null;
let footnotesInstance = null;
let keyfigureTabsInstance = null;
let lazyLoadInstance = null;
let linkInstance = null;
let memberInstance = null;
let navigationInstance = null;
let navigationReponsiveInstance = null;
let readingProgressInstance = null;
let screenVideoInstance = null;
let searchCounterInstance = null;
let shareholderLetterInstance = null;
let sliderInstance = null;
var swiperInstance = null;
let stickyNavInstance = null;
let videoInstance = null;
let griInstance = null;
let symbolsInstance = null;
let svgLightboxInstance = null;

export default {
  version: () => {
    return NSContext.theme.version;
  },

  lazyload: (givenNodeset) => {
    lazyLoadInstance.update(givenNodeset);
  }
};

document.addEventListener("DOMContentLoaded", function () {

  var scrollContainers = document.querySelectorAll('.three-col-container-svg, .chart-container__full-width, .full-width-chart');
  scrollContainers.forEach(function (container) {
    container.addEventListener('scroll', function () {
      this.style.overflowX = 'scroll';
    });
    if (!container.closest('.lc-columns')) {
      container.addEventListener('scroll', function () {
        this.style.overflowX = 'scroll';
      });
    }
  });


  // Free-html: <lottie-player class="lottieplayer" src="…/file.json" speed="1"></lottie-player>
  new LottieScrollAnimator('lottie-player, dotlottie-player, .lottieplayer');
  window.setTimeout(() => {
    new LottieScrollAnimator('lottie-player, dotlottie-player, .lottieplayer');
  }, 300);

  chartsInPopUp = new ChartsInPopUp();

  chapterVideoInstance = new ChapterVideo();

  symbolsInstance = new Symbols();

  accordionInstance = new Accordion();

  megatrendCardInstance = new MegatrendCard();

  anchorInstance = new Anchor();

  boxStoryInstance = new BoxStory();

  backToTopInstance = new BackToTop();

  downloadcenterInstance = new DownloadCenter();

  flipboxInstance = new Flipbox();
  flipboxSliderInstance = new FlipboxSlider();

  griInstance = new GRI();

  new Worldmap();

  footnotesInstance = new Footnotes();

  keyfigureTabsInstance = new KeyfigureTabs();

  lazyLoadInstance = new LazyLoad();

  notesLazyLoadInstance = new NotesLazyLoad();

  linkInstance = new Link();

  memberInstance = new Member();

  navigationInstance = new Navigation();

  navigationReponsiveInstance = new NavigationResponsive();

  readingProgressInstance = new ReadingProgress();

  screenVideoInstance = new ScreenVideo();

  searchCounterInstance = new SearchCounter();

  shareholderLetterInstance = new ShareholderLetter();

  sliderInstance = new Slider();

  stickyNavInstance = new StickyNav();

  swiperInstance = new swiper('.lc-slider-highlights > .swiper', {
    slidesPerView: 3,
    centeredSlides: false,
    wrapperClass: 'swiper-wrapper',
    initialSlide: 0,
    loop: true,
    spaceBetween: 24,
    autoplay: {
      delay: 3500,
      disableOnInteraction: true,
    },
    navigation: {
      nextEl: ".lc-slider-frontpage__next",
      prevEl: ".lc-slider-frontpage__prev",
    },

    breakpoints: {
      512: {
        initialSlide: 0,
        spaceBetween: 24,
        slidesPerView: 1,
        centeredSlides: false,
      },
      798: {
        initialSlide: 0,
        spaceBetween: 24,
        slidesPerView: 2,
        centeredSlides: false,
      },
      1024: {
        initialSlide: 0,
        spaceBetween: 24,
        slidesPerView: 2,
        centeredSlides: false,
      },
      1330: {
        initialSlide: 0,
        spaceBetween: 24,
        slidesPerView: 3,
        centeredSlides: false,
      }
    },
  });

  document.querySelectorAll('.lc-slider-highlights__prev').forEach(p => {
    p.addEventListener('click', (e) => {
      swiperInstance.slidePrev();
    })
  });

  document.querySelectorAll('.lc-slider-highlights__next').forEach(p => {
    p.addEventListener('click', (e) => {
      swiperInstance.slideNext();
    })
  });



  videoInstance = new Video();

  svgLightboxInstance = new SVGLightboxInstance();

  responsiveTableInstance = new ResponsiveTable({
    tableSelector: ".lc-table-wrap table",
    tableWrapperSelector: ".lc-table-wrap",
    breakPointLg: 3000,
    breakPointMd: 768,
    breakPointSm: 480,
    colCountNoSplit: 3,
    colCountEarlyBreak: 20,
    noSplitArray: [],
  });
});
